<template>
  <div class="">
    <div class="container pt-3 m-auto text-left ">
       
      <b-row>
        <b-col cols="6">
          <b-form-group  name="rango_inicial" id="input-rango_inicial" label="Rango inicial:" label-for="rango_inicial">
            <b-form-input disabled id="rango_inicial" type="number" v-model="logro.rango_inicial"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group name="rango_final" id="input-rango_final" label="Rango final:" label-for="rango_final">
            <b-form-input disabled id="rango_final" type="number" v-model="logro.rango_final"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">

          <div class="mt-3">Archivo: {{ logro.archivo_nombre }}</div>

        </b-col>
      </b-row>

      <b-row class="mb-3 mt-2">
        <b-col cols="12">
          <button class="btn btn-block btn-secondary" type="button" @click="cerrar">Cerrar</button>
        </b-col>
      </b-row>
      
    </div>
  </div>
  
</template>


<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  
  export default {
    name: 'LogroDetalle',
    components: {
      
    },
    data () {
      return {
        
      }
    },
    props: {
      logro:Object
    },
    mounted () {
     
    },
    
    methods:{
        ...mapActions({
            setWarning: 'setWarning',
        }),
      ...mapMutations({
        
      }),
      
      cerrar() {
        this.$emit("cerrar")
      }

    },
    computed:{
      ...mapState({
        detalle: state => state.temas.detalle, 
        warning: state => state.warning,
        detalle_curso: state => state.cursos.detalle, 
      }),

      curso(){
        return this.detalle_curso[this.curso_id]
      },
      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>
